import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import QuoteModal from "@/components/site/QuoteModal";
import MobileStickyBar from "@/components/site/MobileStickyBar";
import ShikinChat from "@/components/site/ShikinChat";

const QuoteContext = createContext({ openQuote: () => {}, closeQuote: () => {} });

export const useQuote = () => useContext(QuoteContext);

const AUTO_OPEN_MS = 15000;
const SEEN_KEY = "ptwa_quote_seen";

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const openQuote = useCallback(() => setOpen(true), []);
  const closeQuote = useCallback(() => setOpen(false), []);

  const isAdmin = location.pathname.startsWith("/admin");
  // The /quote ad landing page and /thank-you confirmation page are
  // intentionally distraction-free: no auto-popup, no sticky bar, no chat.
  const isAdLanding = location.pathname === "/quote" || location.pathname === "/thank-you";

  // Gently auto-open once per session on public pages (skip admin, /contact,
  // /quote and /thank-you — those pages carry a form or are post-submit).
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    if (["/contact", "/quote", "/thank-you"].includes(location.pathname)) return;
    if (sessionStorage.getItem(SEEN_KEY)) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem(SEEN_KEY, "1");
    }, AUTO_OPEN_MS);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <QuoteContext.Provider value={{ openQuote, closeQuote }}>
      {children}
      <QuoteModal open={open} onClose={closeQuote} />
      {!isAdmin && !isAdLanding && !open && <MobileStickyBar onQuote={openQuote} />}
      {!isAdmin && !isAdLanding && <ShikinChat />}
    </QuoteContext.Provider>
  );
}
